module.exports = __webpack_public_path__ + "static/assets/d290a2f6958b222711fb4d56966c3978.png";